import { ModuleWithProviders, NgModule } from '@angular/core';
import { APP_BASE_HREF, CommonModule, PlatformLocation } from '@angular/common';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { PermissionRoutingService } from './permission-routing.service';
import { SitePermissionEditorComponent } from './site-permission-editor/site-permission-editor.component';
import { SitePermissionViewerComponent } from './site-permission-viewer/site-permission-viewer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatModule } from '../mat.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { OrgSiteSelectionComponent } from './org-site-selection/org-site-selection.component';
import { FileUploadDisplayComponent } from './file-upload-display/file-upload-display.component';
import { FileUploadDragDropDirective } from './file-upload-drag-drop/file-upload-drag-drop.directive';
import { ToggleComponent } from './toggle/toggle.component';

@NgModule({
    declarations: [
        ContextMenuComponent,
        OrgSiteSelectionComponent,
        SitePermissionEditorComponent,
        SitePermissionViewerComponent,
        FileUploadDisplayComponent,
        FileUploadDragDropDirective,
        ToggleComponent
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule,
        MatModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        RouterModule
    ],
    exports: [
        ContextMenuComponent,
        OrgSiteSelectionComponent,
        SitePermissionEditorComponent,
        SitePermissionViewerComponent,
        MatModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        FileUploadDisplayComponent,
        FileUploadDragDropDirective,
        ToggleComponent
    ],
    providers: [
        {
            provide: APP_BASE_HREF,
            useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
            deps: [PlatformLocation]
        }
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [PermissionRoutingService]
        };
    }
}
